export default __webpack_public_path__ + "static/media/TL02.46b67610.mp3";